import {
    AvailableContingentsRequestParams,
    AvailableContingentsRequest,
    AvailableContingentsResult,
} from "../Definitions";

export const requestApi = (api: string): AvailableContingentsRequest =>
    (params: AvailableContingentsRequestParams) => {
        return new Promise<AvailableContingentsResult[]|null>((resolve) => {
            const url = new URL(api);

            url.searchParams.append("query", JSON.stringify(params));

            (async () => {
                const response = await fetch(url.toString());

                if (response.status === 200) {
                    const data = await response.json() as AvailableContingentsResult[];
                    resolve(data);
                }
                resolve(null);
            })();
        });
    };
